import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledSearchResults = styled.div`
  height: 100vh;
`;

export const ColoredText = styled.span<{ colorVariant: 'warn' | 'urgent' }>(
  ({
    colorVariant,
    theme: {
      base: { palette }
    }
  }) => {
    return css`
      color: ${palette[colorVariant]};
    `;
  }
);

ColoredText.defaultProps = defaultThemeProp;
